import Guardian from "./Guardian";
import common from "../../common";

export default class GuardianElf extends Guardian {
    constructor(golden = false) {
        super("guardian_elf_male", Guardian.TYPE_ELF, golden);

        this.setIdleAnims(["idle1_elf"]);
        this.setAttackAnims(["attack_elf"]);
        this.setDamageAnims(["damage_elf"]);
        this.setDefeatAnims(["defeat_elf"]);
        this.setVictoryAnims(["victory_elf"]);
        this.setWeaponRevealAnims(["weapon_reveal_elf"]);

        this._attackSoundName = "sfx_guardian_arrow_attack_00";
    }
}